import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-app-navbar',
    templateUrl: './app-navbar.component.html',
    styleUrls: ['./app-navbar.component.css'],
    standalone: false
})
export class AppNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
